import * as tslib_1 from "tslib";
import DockingPluginBase from './DockingPluginBase';
import { updateStickyDocking } from './actions/calculateDocking';
var StickyDockingPlugin = /** @class */ (function (_super) {
    tslib_1.__extends(StickyDockingPlugin, _super);
    function StickyDockingPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'StickyDocking';
        _this.onScrollContainerChanged = function (scrollContainer) {
            _this.updateIntersectionObserver();
        };
        return _this;
    }
    StickyDockingPlugin.prototype.initialize = function (editor) {
        _super.prototype.initialize.call(this, editor);
        this.updateIntersectionObserver();
        this.tryScrollIntoView();
    };
    StickyDockingPlugin.prototype.dispose = function () {
        this.updateIntersectionObserver();
        _super.prototype.dispose.call(this);
    };
    StickyDockingPlugin.prototype.setStickyBottomBorder = function (div) {
        this.stickyBottomBorder = div;
        this.updateIntersectionObserver();
    };
    StickyDockingPlugin.prototype.setInitialVisiblePart = function (initialVisiblePart) {
        _super.prototype.setInitialVisiblePart.call(this, initialVisiblePart);
        this.updateIntersectionObserver();
    };
    StickyDockingPlugin.prototype.updateIntersectionObserver = function () {
        var _this = this;
        var scrollContainer = this.scrollAdapter.getScrollContainer();
        // TODO: Once we support compose projection window, need to make sure the observer code works well in projection window
        // We can check this.viewState.isPopout to know if this is in popout window
        if (this.stickyBottomBorder && this.editor && scrollContainer) {
            if (!this.intersectionObserver) {
                this.intersectionObserver = new IntersectionObserver(function (entries) {
                    if (entries[0]) {
                        updateStickyDocking(_this.viewState, entries[0].intersectionRatio != 1);
                    }
                }, {
                    rootMargin: '0px',
                    threshold: [1],
                    root: scrollContainer,
                });
                this.intersectionObserver.observe(this.stickyBottomBorder);
            }
        }
        else {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        }
    };
    return StickyDockingPlugin;
}(DockingPluginBase));
export default StickyDockingPlugin;
//# sourceMappingURL=StickyDockingPlugin.js.map